export default __webpack_public_path__ + "static/media/course-symb.e538e87b.svg";